import { defineComponent, resolveComponent, openBlock, createElementBlock, Fragment, createBlock, resolveDynamicComponent, withCtx, createTextVNode, toDisplayString, createCommentVNode, renderList, createElementVNode, normalizeClass } from 'vue';

var script = defineComponent({
  name: 'block-flexbox',
  props: ["block"],

  data() {
    return {
      containerStyle: null,
      itemStyles: []
    };
  },

  created() {
    this.refresh();
  },

  computed: {
    classes() {
      const result = ['flexbox', `flexbox--${this.block._uid}`];

      if (this.block.cssClass) {
        result.push(this.block.cssClass);
      }

      return result;
    },

    generalDefaultItemsStyle() {
      const result = [];

      if (this.block.itemsDefaultBackgroundColor) {
        result.push(`background-color:${this.block.itemsDefaultBackgroundColor}`);
      }

      return result.join(';');
    }

  },
  watch: {
    block(_, oldVal) {
      if (!oldVal) {
        return;
      }

      this.refresh();
    }

  },
  methods: {
    refresh() {
      var _this$block$items;

      this.containerStyle = [this.buildStyleRule(`.flexbox--${this.block._uid}`, this.getContainerGeneralStyle()), this.buildStyleRule(`.flexbox__item--${this.block._uid}`, this.generalDefaultItemsStyle), this.buildStyleRule(`.flexbox--${this.block._uid}`, this.getContainerStyle('Small')), this.buildStyleRule(`.flexbox__item--${this.block._uid}`, this.getItemDefaultStyle('Small')), this.buildStyleRule(`@media (min-width: ${this.block.breakpointMedium}px)`, [this.buildStyleRule(`.flexbox--${this.block._uid}`, this.getContainerStyle('Medium')), this.buildStyleRule(`.flexbox__item--${this.block._uid}`, this.getItemDefaultStyle('Medium'))]), this.buildStyleRule(`@media (min-width: ${this.block.breakpointLarge}px)`, [this.buildStyleRule(`.flexbox--${this.block._uid}`, this.getContainerStyle('Large')), this.buildStyleRule(`.flexbox__item--${this.block._uid}`, this.getItemDefaultStyle('Large'))])].filter(r => r).join(' ');
      this.itemStyles = (_this$block$items = this.block.items) === null || _this$block$items === void 0 ? void 0 : _this$block$items.map(item => {
        return [this.buildStyleRule(`.flexbox__item--${this.block._uid}.flexbox__item--${item._uid}`, this.getItemGeneralStyle(item)), this.buildStyleRule(`.flexbox__item--${this.block._uid}.flexbox__item--${item._uid}`, this.getItemStyle('Small', item)), this.buildStyleRule(`@media (min-width: ${this.block.breakpointMedium}px)`, this.buildStyleRule(`.flexbox__item--${this.block._uid}.flexbox__item--${item._uid}`, this.getItemStyle('Medium', item))), this.buildStyleRule(`@media (min-width: ${this.block.breakpointLarge}px)`, this.buildStyleRule(`.flexbox__item--${this.block._uid}.flexbox__item--${item._uid}`, this.getItemStyle('Large', item)))].filter(r => r).join(' ');
      }).filter(r => r);
    },

    getItemClasses(item) {
      return ['flexbox__item', `flexbox__item--${this.block._uid}`, `flexbox__item--${item._uid}`];
    },

    getStyleValue(property, field, device) {
      if (!this.block[field + device]) {
        return null;
      }

      return `${property}: ${this.block[field + device]};`;
    },

    getItemStyleValue(item, property, field, device) {
      if (!item[field + device]) {
        return null;
      }

      return `${property}: ${item[field + device]};`;
    },

    buildStyleRule(selector, properties) {
      if (!properties) {
        return;
      }

      if (typeof properties !== 'string') {
        return `${selector}{${properties.join(' ')}}`;
      }

      return `${selector}{${properties}}`;
    },

    getContainerGeneralStyle() {
      const result = [];
      result.push(this.getStyleValue('background-color', 'backgroundColor', ''));
      return result.join('');
    },

    getContainerStyle(device) {
      const result = [];
      result.push(this.getStyleValue('flex-direction', 'direction', device));
      result.push(this.getStyleValue('justify-content', 'justifyContent', device));
      result.push(this.getStyleValue('margin', 'margin', device));
      result.push(this.getStyleValue('padding', 'padding', device));
      result.push(this.getStyleValue('width', 'width', device));
      result.push(this.getStyleValue('height', 'height', device));
      result.push(this.getStyleValue('max-width', 'maxWidth', device));
      result.push(this.getStyleValue('max-height', 'maxHeight', device));
      result.push(this.getStyleValue('align-items', 'alignItems', device));

      if (this.block[`wrap${device}`]) {
        result.push('flex-wrap: wrap');
      }

      return result.join('');
    },

    getItemGeneralDefaultStyle() {
      const result = [];
      result.push(this.getStyleValue('background-color', 'backgroundColor', ''));
      return result.join('');
    },

    getItemDefaultStyle(device) {
      const result = [];
      result.push(this.getStyleValue('flex', 'itemsDefaultFlex', device));
      result.push(this.getStyleValue('width', 'itemsDefaultWidth', device));
      result.push(this.getStyleValue('height', 'itemsDefaultHeight', device));
      result.push(this.getStyleValue('max-width', 'itemsDefaultMaxWidth', device));
      result.push(this.getStyleValue('max-height', 'itemsDefaultMaxHeight', device));
      result.push(this.getStyleValue('margin', 'itemsDefaultMargin', device));
      result.push(this.getStyleValue('padding', 'itemsDefaultPadding', device));
      result.push(this.getStyleValue('border', 'itemsDefaultBorder', device));
      result.push(this.getStyleValue('border-radius', 'itemsDefaultBorderRadius', device));
      return result.join('');
    },

    getItemGeneralStyle(item) {
      const result = [];
      result.push(this.getItemStyleValue(item, 'background-color', 'backgroundColor', ''));
      return result.join('');
    },

    getItemStyle(device, item) {
      const result = [];
      result.push(this.getItemStyleValue(item, 'margin', 'margin', device));
      result.push(this.getItemStyleValue(item, 'padding', 'padding', device));
      result.push(this.getItemStyleValue(item, 'flex', 'flex', device));
      result.push(this.getItemStyleValue(item, 'width', 'width', device));
      result.push(this.getItemStyleValue(item, 'height', 'height', device));
      result.push(this.getItemStyleValue(item, 'max-width', 'maxWidth', device));
      result.push(this.getItemStyleValue(item, 'max-height', 'maxHeight', device));
      result.push(this.getItemStyleValue(item, 'align-self', 'alignSelf', device));
      result.push(this.getItemStyleValue(item, 'order', 'order', device));
      result.push(this.getItemStyleValue(item, 'overflow', 'overflow', device));
      result.push(this.getItemStyleValue(item, 'border', 'border', device));
      result.push(this.getItemStyleValue(item, 'border-radius', 'borderRadius', device));
      return result.join('');
    }

  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_container = resolveComponent("block-container");

  return openBlock(), createElementBlock(Fragment, null, [_ctx.containerStyle ? (openBlock(), createBlock(resolveDynamicComponent('style'), {
    key: 0,
    type: "text/css"
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.containerStyle), 1)]),
    _: 1
  })) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemStyles, (val, idx) => {
    return openBlock(), createBlock(resolveDynamicComponent('style'), {
      type: "text/css",
      key: idx
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(val), 1)]),
      _: 2
    }, 1024);
  }), 128)), createElementVNode("div", {
    class: normalizeClass(_ctx.classes)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.block.items, item => {
    return openBlock(), createBlock(_component_block_container, {
      class: normalizeClass(_ctx.getItemClasses(item)),
      key: item._uid,
      block: item.content[0]
    }, null, 8, ["class", "block"]);
  }), 128))], 2)], 64);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\n.flexbox {\r\n  display: flex;\n}\r\n";
styleInject(css_248z);

script.render = render;

// Import vue component

// Default export is installable instance of component.
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),
var entry_esm = /*#__PURE__*/(() => {
  // Assign InstallableComponent type
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('StoryblokFlexbox', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
